class TitleCasePipe {
  transform(text) {
    if (text) {
      const tokens = text.split("_");
      return tokens
        .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
        .join(" ");
    }
    return text;
  }
}

const titleCasePipe = new TitleCasePipe();
export default titleCasePipe;
